import React, { useEffect, useState } from "react";
import Layout from "../layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";
import axios from "axios";
import {
  Form,
  Row,
  Col,
  Button,
  Card,
  Breadcrumb,
  Alert,
} from "react-bootstrap";

const LogistikListAdd = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);
  const [asal, setAsal] = useState("");
  const [PolisiKendaraan, setPolisiKendaraan] = useState("");
  const [jenisKendaraan, setjenisKendaraan] = useState("");
  const [kapasitasAngkut, setkapasitasAngkut] = useState("");
  const [msg, setMsg] = useState("");

  const saveLogistik = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token");

    try {
      await axios.post(
        `https://c-greenproject.org:8000/logistikdasar`,
        {
          asal,
          PolisiKendaraan,
          jenisKendaraan,
          kapasitasAngkut: Number(kapasitasAngkut),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      navigate("/data-logistik");
    } catch (error) {
      if (error.response) {
        setMsg(error.response.data.msg);
      }
    }
  };

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    if (user && user.role !== "admin" && user.role !== "logistik") {
      navigate("/dashboard");
    }
  }, [isError, user, navigate]);

  return (
    <Layout>
      <Breadcrumb>
        <Breadcrumb.Item href="/data-logistik">Data Logistik</Breadcrumb.Item>
        <Breadcrumb.Item active>Add Data Logistik</Breadcrumb.Item>
      </Breadcrumb>

      <h2 className="title">
        <strong>Add Data Logistik</strong>
      </h2>

      <Card className="mb-4">
        <Card.Body>
          <Form onSubmit={saveLogistik}>
            {msg && <Alert variant="danger">{msg}</Alert>}

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formAsal">
                <Form.Label>Asal</Form.Label>
                <Form.Control
                  type="text"
                  value={asal}
                  onChange={(e) => setAsal(e.target.value)}
                  placeholder="Masukkan Asal"
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formPolisiKendaraan">
                <Form.Label>Nomor Polisi Kendaraan</Form.Label>
                <Form.Control
                  type="text"
                  value={PolisiKendaraan}
                  onChange={(e) => setPolisiKendaraan(e.target.value)}
                  placeholder="Masukkan Nomor Polisi Kendaraan"
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formJenisKendaraan">
                <Form.Label>Jenis Kendaraan</Form.Label>
                <Form.Control
                  type="text"
                  value={jenisKendaraan}
                  onChange={(e) => setjenisKendaraan(e.target.value)}
                  placeholder="Masukkan Jenis Kendaraan"
                />
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col} controlId="formKapasitasAngkut">
                <Form.Label>Kapasitas Angkut (kg)</Form.Label>
                <Form.Control
                  type="number"
                  value={kapasitasAngkut}
                  onChange={(e) => setkapasitasAngkut(e.target.value)}
                  placeholder="Masukkan Kapasitas Angkut"
                />
              </Form.Group>
            </Row>

            <Button variant="success" type="submit">
              Save
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </Layout>
  );
};

export default LogistikListAdd;
